import _ from 'lodash'

const IGNORE_FILTER_IDS = [
  'search_query',
  'locations_single',
  'category_list',
  'seller_types_common',
  'cars',
  'seller_types_cars',
  'countries',
  'boat_length_feet',
  'boat_length_meters',
]
const IGNORE_FILTER_DATA_GROUPS = ['sort_orders', 'clothing_kind', 'clothing_size']

export const getActiveFilters = (state) => {
  const result = [..._.get(state, 'searchParams.activeParameters', [])]
    .filter(({ id, dataGroup }) => {
      return !(IGNORE_FILTER_IDS.includes(id) || IGNORE_FILTER_DATA_GROUPS.includes(dataGroup))
    })
    .sort((a, b) => {
      return a.sortKey - b.sortKey
    })
  const carFaxIndex = _.findIndex(result, { id: 'cars_free_carfax' })
  const premiumWarrantyIndex = _.findIndex(result, { id: 'cars_premium_warranty' })

  const tmp = result[carFaxIndex]
  result[carFaxIndex] = result[premiumWarrantyIndex]
  result[premiumWarrantyIndex] = tmp

  return result
}

const PLACEMENTS = {
  TOP: 'TOP',
  TOP_BOOLEAN: 'TOP_BOOLEAN',
  BOOLEAN: 'BOOLEAN',
  GRID: 'GRID',
  SPECIAL: 'SPECIAL',
}

const PLACEMENT_DATA_GROUP_MAP = {
  ad_types: PLACEMENTS.TOP,
}

export const PLACEMENT_ID_MAP = {
  // fordon - bilar
  car_prices_cars: PLACEMENTS.GRID,
  cars_model_year: PLACEMENTS.GRID,
  cars_mileage: PLACEMENTS.GRID,
  cars_fuel: PLACEMENTS.GRID,
  car_chassis: PLACEMENTS.SPECIAL,
  cars_gearbox: PLACEMENTS.GRID,
  car_colors: PLACEMENTS.SPECIAL,
  cars_drive_wheels: PLACEMENTS.BOOLEAN,
  cars_engine_power: PLACEMENTS.GRID,
  car_insurance: PLACEMENTS.BOOLEAN,
  cars_free_carfax: PLACEMENTS.BOOLEAN,
  cars_premium_warranty: PLACEMENTS.BOOLEAN,
  cars_leasing: PLACEMENTS.SPECIAL,

  // fordon - misc
  vehicle_prices: PLACEMENTS.GRID,
  machine_prices: PLACEMENTS.GRID,
  moped_prices: PLACEMENTS.GRID,
  commercial_property_prices: PLACEMENTS.GRID,
  floor_area_commercial: PLACEMENTS.GRID,
  beds: PLACEMENTS.GRID,
  living_situation: PLACEMENTS.GRID,

  // fordon - båtar
  boat_prices: PLACEMENTS.GRID,

  // fordon - motorcyklar
  motorcycles_regdate: PLACEMENTS.GRID,
  hide_atv: PLACEMENTS.BOOLEAN,

  // bostad
  prices_homes: PLACEMENTS.GRID,
  monthly_rent: PLACEMENTS.GRID,
  floor_area_homes: PLACEMENTS.GRID,
  rooms: PLACEMENTS.GRID,

  // Personligt
  clothing_gender: PLACEMENTS.BOOLEAN,
  clothing_children_gender: PLACEMENTS.BOOLEAN,

  // misc
  shipping_enabled: PLACEMENTS.TOP_BOOLEAN,
  price_lowered: PLACEMENTS.TOP_BOOLEAN,
}

const BOOLEAN_HEADER_CATEGORY_MAP = {
  1020: 'Visa endast:',
  1140: 'Fler val:',
}

export const getFilterPlacements = (state, currentQuery) => {
  const filters = getActiveFilters(state)

  const out = {
    booleanHeader: BOOLEAN_HEADER_CATEGORY_MAP[currentQuery.cg],
    placements: {
      [PLACEMENTS.TOP]: [],
      [PLACEMENTS.TOP_BOOLEAN]: [],
      [PLACEMENTS.BOOLEAN]: [],
      [PLACEMENTS.GRID]: [],
      [PLACEMENTS.SPECIAL]: [],
    },
  }

  filters.forEach((filter) => {
    const placement = PLACEMENT_ID_MAP[filter.id] || PLACEMENT_DATA_GROUP_MAP[filter.dataGroup]
    if (placement) {
      out.placements[placement].push(filter)
    } else if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('no placement for filter', filter.id, filter)
    }
  })

  return out
}
